import { type ReactNode } from 'react';
import { BottomNav } from './BottomNav';
import { BottomSheet } from './BottomSheet';
import { GracePeriodBanner } from './GracePeriodBanner';
import { useTabNavigationStore } from '../../store/tabNavigationStore';
import type { Tab } from '../../types/domain';

interface AppShellProps {
  children: ReactNode;
  hubContent?: ReactNode;
  orgSwitcherContent?: ReactNode;
  directionSwitcherContent?: ReactNode;
}

/**
 * AppShell - Main layout wrapper with bottom navigation and sheets
 * Manages tab-based navigation and bottom sheets (Hub, Organization, Direction)
 */
export const AppShell = ({
  children,
  hubContent,
  orgSwitcherContent,
  directionSwitcherContent
}: AppShellProps) => {
  const {
    activeTab,
    switchTab,
    openHub,
    isHubOpen,
    closeHub,
    isOrgSwitcherOpen,
    closeOrgSwitcher,
    isDirectionSwitcherOpen,
    closeDirectionSwitcher,
  } = useTabNavigationStore();

  const handleTabChange = (tab: Tab | 'hub') => {
    if (tab === 'hub') {
      openHub();
    } else {
      switchTab(tab);
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <main className="pb-16">
        <GracePeriodBanner />
        {children}
      </main>

      {!isHubOpen && (
        <BottomNav
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
      )}

      {/* AI Hub Bottom Sheet */}
      <BottomSheet isOpen={isHubOpen} onClose={closeHub} height="94%" title="Штаб">
        {hubContent}
      </BottomSheet>

      {/* Organization Switcher Bottom Sheet */}
      <BottomSheet isOpen={isOrgSwitcherOpen} onClose={closeOrgSwitcher} height="45%">
        {orgSwitcherContent}
      </BottomSheet>

      {/* Direction Switcher Bottom Sheet */}
      <BottomSheet isOpen={isDirectionSwitcherOpen} onClose={closeDirectionSwitcher} height="40%">
        {directionSwitcherContent}
      </BottomSheet>
    </div>
  );
};
